export const FIELDS = {
  PLEASE_SELECT: 'placeholder',
  VIDEO_TITLE: 'title',
  CHANNEL_SELECT: 'channels',
  KEYWORDS: 'keywords',
  DESCRIPTION: 'description',
  LANGUAGE_SELECT: 'languages',
  COUNTRY_SELECT: 'countries',
  TEXT_BOX: 'text_box',
  THUMBNAIL: 'thumbnail', // used only in my-videos>edit page
};
